import {
  blue,
  green,
  lightYellow,
  red,
  orange,
  purple,
  yellow,
  lightOrange,
  lightTeal,
  lightBlue,
} from '@synoptic/ui-kit/palette.js';

export const highlightStyles = {
  lightYellow: {
    backgroundColor: lightYellow[100],
    borderBottom: lightYellow[500],
  },
  lightOrange: {
    backgroundColor: lightOrange[100],
    borderBottom: lightOrange[500],
  },
  lightTeal: {
    backgroundColor: lightTeal[100],
    borderBottom: lightTeal[500],
  },
  lightBlue: {
    backgroundColor: lightBlue[100],
    borderBottom: lightBlue[500],
  },
  yellow: {
    backgroundColor: yellow[100],
    borderBottom: yellow[500],
  },
  green: {
    backgroundColor: green[100],
    borderBottom: green[300],
  },
  blue: {
    backgroundColor: blue[100],
    borderBottom: blue[300],
  },
  red: {
    backgroundColor: red[100],
    borderBottom: red[300],
  },
  orange: {
    backgroundColor: orange[100],
    borderBottom: orange[300],
  },
  purple: {
    backgroundColor: purple[100],
    borderBottom: purple[300],
  },
} as const;

export type HighlightColor = keyof typeof highlightStyles;

export interface HighlightPattern {
  color?: HighlightColor;
  regex: string;
  priority?: number;
}
